import { render, staticRenderFns } from "./nothing.vue?vue&type=template&id=096dbe4f&scoped=true&"
import script from "./nothing.vue?vue&type=script&lang=js&"
export * from "./nothing.vue?vue&type=script&lang=js&"
import style0 from "./nothing.vue?vue&type=style&index=0&id=096dbe4f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096dbe4f",
  null
  
)

export default component.exports